module.exports = __webpack_public_path__ + "img/plug-fill.d9268270.svg";